import React from "react";

import { Textarea } from "@/components/ui/textarea";
import { Variable } from "@/components/InputVariableConfigurator/types";

interface TestRunInputVariablesProps {
  inputVariables: Variable[];
  inputValues: Record<string, string | object>;
  onInputChange: (key: string, value: string) => void;
}

export const TestRunInputVariables: React.FC<TestRunInputVariablesProps> = ({
  inputVariables,
  inputValues,
  onInputChange,
}) => {
  if (inputVariables.length === 0) {
    return <p className="text-sm text-gray-500">No input variables required for this workflow.</p>;
  }

  return (
    <div className="space-y-4">
      {inputVariables.map(variable => (
        <div key={variable.key}>
          <label htmlFor={variable.key} className="mb-1 block text-sm font-medium text-gray-700">
            {variable.key}
            {/* @ts-expect-error - TODO: fix this */}
            {variable.required && <span className="ml-1 text-red-500">*</span>}
          </label>
          <Textarea
            id={variable.key}
            value={
              typeof inputValues[variable.key] === "object"
                ? JSON.stringify(inputValues[variable.key], null, 2)
                : (inputValues[variable.key] as string) || ""
            }
            onChange={e => onInputChange(variable.key, e.target.value)}
            placeholder={`Enter ${variable.key}...`}
            className="min-h-[80px] font-mono text-sm"
            rows={3}
          />
          {/* @ts-expect-error - TODO: fix this */}
          {variable.description && (
            // @ts-expect-error - TODO: fix this
            <p className="mt-1 text-xs text-gray-500">{variable.description}</p>
          )}
        </div>
      ))}
    </div>
  );
};
